import { ConfiguratorFieldDepencencyController } from "../configurator-field-dependency-controller";

export class FieldDepencencyController {
    constructor(element) {

        this.fields = [];
        this.fieldsDependencyController = new ConfiguratorFieldDepencencyController();
        
        Array.from(document.querySelectorAll('.configurator-field')).forEach(e => {
            
            var field = JSON.parse(e.innerHTML);
            var controlToHide = document.getElementById(field.controlToHideId);
            var htmlInput = document.getElementById(field.htmlInputId);

            var getValueCallback;

            if(field.type === "TextBox" || field.type === "TextArea"){
                getValueCallback = (currentField) => {            
                    return document.getElementById(field.htmlInputId).value;
                };
            } else if(field.type === "FileUpload"){
                getValueCallback =(currentField) => {
                    return currentField.inputs[0].files.length === 1;
                };
            } else if (field.type === "CategorizedMultiselector"){
                getValueCallback = (currentField) => {
                    return currentField.inputs.filter(x => x.checked).map(field => !field.dataset.usevaluefromcheckbox ? field.checked : field.value);
                };
            } else if (field.type === "Checkbox"){
                getValueCallback = (currentField) => {
                    return !currentField.inputs[0].dataset.usevaluefromcheckbox ? currentField.inputs[0].checked.toString() : currentField.inputs[0].value;
                };
            } 
   
            this.fieldsDependencyController.setDependencyOnField({
                field,
                htmlInput,
                controlToHide,                
                triggerOnEvent: field.triggerOnEvent,
                getValueCallback,
                onVisiblityChange: () => {}
            });

            this.fieldsDependencyController.createDepdencyMap();
        });
    }    
}
